module.exports = __webpack_public_path__ + "img/feature_d02.927cef03.svg";